import { CloneConsentFnProps, FileUpload, FileUploadSuccess } from '@usacsmideo/types';
import { uploadFile } from '../data/uploadFile';
import { downloadFile } from '../data/downloadFile';
import { getDownloadURL } from 'firebase/storage';
import * as Sentry from '@sentry/browser';

export const cloneConsentSignature = async (payload: CloneConsentFnProps) => {
  // GET THE CONSENT FOR CARE SIGNATURE FILE FROM CLOUD STORAGE
  const file = await downloadFile(payload.originStoragePath);
  const uploadFilePayload = { bucket: payload.bucket, path: payload.destinationStoragePath, file } as FileUpload;

  // UPLOAD THE CONSENT FOR CARE SIGNATURE TO CLONE LOCATION CLOUD STORAGE
  const uploadTask = uploadFile(uploadFilePayload);
  uploadTask.on(
    'state_changed',
    (snapshot) => {
      // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
      const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      console.info('Upload is ' + progress + '% done');
    },
    (error) => {
      Sentry.captureException(error);
      console.error(error);
      alert(`Error uploading file: ${error.message}`);
    },
    () => {
      // UPLOAD SUCCESSFUL
      getDownloadURL(uploadTask.snapshot.ref)
        .then((downloadURL) => {
          // SAVE THE DOWNLOAD URL TO FIRESTORE
          if (downloadURL) {
            const firestorePayload = {
              docToUpdate: payload.docToUpdate,
              patientId: payload.patientId,
              type: payload.type,
              url: downloadURL,
            } as FileUploadSuccess;
            payload.updateFirestore(firestorePayload);
          }
        })
        .catch((error) => {
          Sentry.captureException(error);
          console.error('Error getting download URL:', error);
        });
    },
  );
};
